import React, { useState } from "react";

import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  MenuItem,
  Stack,
  Link,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import CallRoundedIcon from "@mui/icons-material/CallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";

import { Tribuja } from "../../assets";
import CustomInput from "./CoustomInput";
import { AddLead } from '../../api/services'; // Assuming this API service exists
import { useMutation } from "react-query";
import { toast } from "react-toastify";

const ContactSection = () => {
  // ================= FORM STATE =================

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    message: "",
  });

  // ================= HANDLE CHANGE =================

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ================= SUBMIT =================

  const mutation = useMutation(AddLead, {
    onSuccess: () => {
      toast.success('Successfully submitted!');
    },
    onError: (error: any) => {
      toast.error(`${error.response?.data?.message || 'Submission failed'}`);
    },
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const payload = { ...formData, type: 'project', projectName: 'tribuja' };
    mutation.mutate(payload);
  };

  return (
    <Box
      sx={{
        position: "relative",

        width: "100%",

        overflow: "hidden",

        py: {
          xs: 8,
          md: 4,
        },
        // height: {
        //   xs: "auto",
        //   md: "100vh",
        // },
         display: "flex",

        justifyContent: "center",

        alignItems: "center",

        backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg.png")`,

        backgroundSize: "cover",

        backgroundPosition: "center",

        "&::after": {
          content: '""',

          position: "absolute",

          inset: 0,

          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.62), rgba(0,0,0,0.62))",

          zIndex: 1,
        },
      }}
    >
      {/* BLUE GLOW */}

      <Box
        sx={{
          position: "absolute",

          top: "-200px",

          right: "-150px",

          width: {
            xs: "300px",
            md: "700px",
          },

          height: {
            xs: "300px",
            md: "700px",
          },

          background:
            "radial-gradient(circle, rgba(48,119,157,0.35) 0%, rgba(48,119,157,0) 70%)",

          filter: "blur(120px)",

          zIndex: 1,
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 5,
        }}
      >
        <Box sx={{mb:6}}>
          {/* MAIN TITLE */}

          <Typography
            variant="h4"
            sx={{

              
              fontWeight: 500,

              color: "#fff",

              letterSpacing: "1px",

              textTransform: "uppercase",

              mb: 2,
                 fontFamily: "Luxury",
            }}

          >
            Let’s
            Connect
          </Typography>
          <Box
            sx={{
              width: {
                xs: "120px",
                md: "180px",
              },

              height: "2px",

              background:
                "linear-gradient(to right, transparent, #fff, transparent)",

              mx: "auto",

              mb: 3,
            }}
          />

          {/* DESCRIPTION */}

        

        </Box>
        <Grid
          container
          spacing={{
            xs: 5,
            md: 8,
          }}
          alignItems="center"
          
        >
          {/* ================= LEFT CONTENT ================= */}

          <Grid item xs={12} md={5}>
            <Box>
              {/* SMALL TITLE */}




              {/* CONTACT INFO */}
         <Typography
            sx={{
              color: "#d2d2d2",

              fontSize: {
                xs: "14px",
                md: "17px",
              },

              lineHeight: 1.9,

              mt: 2,

              // maxWidth: "500px",
              textAlign:"start",
              // fontFamily: "PoetsenOne",
            }}
          >
            Experience elevated luxury living with iconic
            architecture, skyline residences, and premium
            lifestyle experiences crafted for modern living.
          </Typography>

              <Stack spacing={3} mt={5}>
                {/* PHONE */}


                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#d9f2ff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <PhoneIcon sx={{ color: "#0f172a" }} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "start"
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#7dd3fc",
                        letterSpacing: "3px",
                        fontSize: "14px",
                        mb: 0.5,
                        fontFamily:"Luxury"
                      }}
                    >
                      PHONE
                    </Typography>

                    <Link
                      href="tel:+919549546568"
                      underline="none"
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        transition: "0.3s",
                        fontFamily: "PoetsenOne",
                        "&:hover": {
                          color: "#7dd3fc",
                        },
                      }}
                    >
                      +91 954 954 6568
                    </Link>
                  </Box>
                </Box>

                {/* EMAIL */}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    mb: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#d9f2ff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <EmailIcon sx={{ color: "#0f172a" }} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "start"
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#7dd3fc",
                        letterSpacing: "3px",
                        fontSize: "14px",
                        mb: 0.5,
                        fontFamily:"Luxury"
                      }}
                    >
                      EMAIL
                    </Typography>

                    <Link
                      href="mailto:info@dprprop.com"
                      underline="none"
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        transition: "0.3s",
                        fontFamily: "PoetsenOne",
                        letterSpacing:'1px',
                        "&:hover": {
                          color: "#7dd3fc",
                        },
                      }}
                    >
                      info@dprprop.com
                    </Link>
                  </Box>
                </Box>

                {/* LOCATION */}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#d9f2ff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon sx={{ color: "#0f172a" }} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "start"
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#7dd3fc",
                        letterSpacing: "2px",
                        fontSize: "14px",
                        mb: 0.5,
                        fontFamily:"Luxury"
                      }}
                    >
                      LOCATION
                    </Typography>

                    <Typography
                      // variant="body2"
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontFamily: "PoetsenOne",
                      }}
                    >
                      Hyderabad
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Box>
          </Grid>

          {/* ================= RIGHT FORM ================= */}

          <Grid item xs={12} md={7}>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                p: {
                  xs: 3,
                  md: 5,
                },

                borderRadius: "32px",

                background:
                  "rgba(255,255,255,0.05)",

                border:
                  "1px solid rgba(255,255,255,0.08)",

                backdropFilter: "blur(20px)",

                boxShadow:
                  "0px 20px 60px rgba(0,0,0,0.35)",
              }}
            >
              {/* TITLE */}

              {/* <Typography
                sx={{
                  color: "white",

                  fontSize: {
                    xs: "26px",
                    md: "36px",
                  },

                  fontWeight: 300,

                  mb: 4,
                }}
              >
                Enquire Now
              </Typography> */}

              <Grid container spacing={2}>
                {/* NAME */}

                <Grid item xs={12} md={6}>
                  <CustomInput
                    fullWidth
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    required

                  />
                </Grid>

                {/* PHONE */}

                <Grid item xs={12} md={6}>
                  <CustomInput
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="phoneNumber"
                    fullWidth
                    required
                    value={formData.phoneNumber}
                    onChange={handleChange}

                  

                  />
                </Grid>

                {/* EMAIL */}

                <Grid item xs={12}>
                  <CustomInput
                    fullWidth
                    name="email"
                    type="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}

                    required

                  />
                </Grid>

                {/* INTEREST */}

                {/* <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    variant="outlined"
                    required
                    SelectProps={{
                      displayEmpty: true,
                    }}
                    InputProps={{
                      sx: {
                        color: "white",

                        borderRadius: "16px",

                        background:
                          "rgba(255,255,255,0.04)",

                        "& fieldset": {
                          border:
                            "1px solid rgba(255,255,255,0.08)",
                        },

                        "&:hover fieldset": {
                          border:
                            "1px solid #30779d",
                        },

                        "&.Mui-focused fieldset": {
                          border:
                            "1px solid #30779d",
                        },
                      },
                    }}
                  >
                    <MenuItem value="">
                      Select Interest
                    </MenuItem>

                    <MenuItem value="3BHK">
                      3 BHK
                    </MenuItem>

                    <MenuItem value="4BHK">
                      4 BHK
                    </MenuItem>

                    <MenuItem value="Penthouse">
                      Penthouse
                    </MenuItem>
                  </TextField>
                </Grid> */}

                {/* MESSAGE */}

                <Grid item xs={12}>
                  <CustomInput
                    fullWidth
                    multiline
                    rows={3}
                    name="message"
                    placeholder="Write Your Message"
                    value={formData.message}
                    onChange={handleChange}


                  />
                </Grid>

                {/* BUTTON */}

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    endIcon={
                      <ArrowOutwardRoundedIcon />
                    }
                    sx={{
                      width: {
                        xs: "100%",
                        md: "240px",
                      },

                      height: "40px",

                      borderRadius: "10px",

                      background:
                        "linear-gradient(135deg,#30779d,silver)",

                      color: "white",

                      fontWeight: 700,

                      letterSpacing: 2,

                      fontSize: "14px",

                      boxShadow:
                        "0px 12px 35px rgba(48,119,157,0.4)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg,#30779d,silver)",

                        transform:
                          "translateY(-3px)",
                      },
                    }}
                  >
                     {mutation.isLoading
      ? "Submitting..."
      : "Submit "}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactSection;